import { DialogProps } from '@mui/material';
import { createCtx } from 'v2/core/utils/createCtx';

export interface OpenModalOptions {
  contentComponent: () => JSX.Element;
  modalProps: Omit<DialogProps, 'open' | 'children'> & {
    shouldDisableBackdropClick?: boolean;
  };
}

export interface MuiModalContextType {
  openModal: ({ contentComponent, modalProps }: OpenModalOptions) => string;
  closeModal: (modalId?: string) => void;
  activeModalId?: string;
  activeModalLabel?: string;
}

export const [useMuiModalContext, MuiModalContextProvider] =
  createCtx<MuiModalContextType>();
